import GuidedSearchText from "../../../../../features/browse-search/components/GuidedSearchText";
import BaseCategoryPage from "../../../CategoryPage";

export const CategoryPage = (props) => (
  <BaseCategoryPage {...props} topContent={<GuidedSearchText />} />
);

export default CategoryPage;
